<template>
    <div>
     <mcheader ref="mcheader"></mcheader>
      <div class="cart-banner-area text-center">
        <div class="about-banner-text">
          <div class="banner-title">
            <h2>Shopping cart</h2>
          </div>
          <div class="breadcrumbs">
            <ul>
              <li class="home"><a href="index.html">Home</a><span> > </span></li>
              <li><a href="shop.html">Shop</a> <span> > </span></li>
              <li>cart</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- banner end -->
      <!-- cart start -->
      <div class="cart-area-start">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="cart-tab-menu text-center">
                <ul>
                  <li><a>01. Shopping Cart</a></li>
                  <li><a @click="goorder">02. Checkout</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <form action="#">
                <div class="cart-table table-responsive">
                  <table>
                    <thead>
                    <tr>
                      <th class="p-name">Product Name</th>
                      <th class="p-amount">Unit Price</th>
                      <th class="p-quantity">Quantity</th>
                      <th class="p-total">Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in shopcarList" :key="index">
                      <td class="p-name text-left">
                        <div class="cart-img">
                          <a href="#"><img :src="item.imgUrl" alt=""></a>
                        </div>
                        <a>{{item.name}}</a>
                        <p>Lorem ipsum dolor sit <span>amet, consectetur</span></p>
                        <p class="c-p-size"><span>Size : </span> {{item.norm1}}/{{item.norm2}}</p>
                      </td>
                      <td class="p-amount"><span class="amount">${{item.price}}</span></td>
                      <td class="p-quantity"><input type="text" :value="item.productCount"></td>
                      <td class="p-total">${{item.price*item.productCount}} <a @click="DeleteShop(index)"><i class="fa fa-trash"></i></a></td>
                    </tr>

                    </tbody>
                  </table>
                </div>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="cart-coupn-leftside">
                <!--<div class="section-title">-->
                  <!--<h4>Calculate Shipping</h4>-->
                <!--</div>-->
                <!--<div class="row">-->
                  <!--<div class="col-md-6">-->
                    <!--<div class="shipping-info">-->
                      <!--<select name="country">-->
                        <!--<option>Country</option>-->
                        <!--<option>Bangladesh</option>-->
                        <!--<option>USA</option>-->
                        <!--<option>India</option>-->
                        <!--<option>UK</option>-->
                        <!--<option>Australia</option>-->
                      <!--</select>-->
                    <!--</div>-->
                  <!--</div>-->
                  <!--<div class="col-md-6">-->
                    <!--<div class="shipping-info">-->
                      <!--<select name="state">-->
                        <!--<option>State</option>-->
                        <!--<option>Dhaka</option>-->
                        <!--<option>New York</option>-->
                        <!--<option>Torento</option>-->
                        <!--<option>Tokeyo</option>-->
                        <!--<option>Jakarta</option>-->
                      <!--</select>-->
                    <!--</div>-->
                  <!--</div>-->
                  <!--<div class="col-md-6">-->
                    <!--<div class="shipping-info">-->
                      <!--<select name="zip">-->
                        <!--<option>Postcode/Zip</option>-->
                        <!--<option>008</option>-->
                        <!--<option>001</option>-->
                        <!--<option>007</option>-->
                        <!--<option>002</option>-->
                        <!--<option>009</option>-->
                      <!--</select>-->
                    <!--</div>-->
                  <!--</div>-->
                  <!--<div class="col-md-6">-->
                    <!--<div class="shipping-info">-->
                      <!--<button>Estimate</button>-->
                    <!--</div>-->
                  <!--</div>-->
                <!--</div>-->
                <div class="row">
                  <div class="col-xs-12">
                    <div class="section-title">
                      <h4>Discount Coupon Code</h4>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="cpn-code">
                      <input type="text" placeholder="Coupon Code">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="shipping-info">
                      <button>Apply Code</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="cart-coupon-rightside">
                <div class="section-title">
                  <h4>cart total</h4>
                </div>
                <div class="amount-table table-responsive">
                  <table>
                    <tbody>
                    <tr class="s-total">
                      <td>Sub Total <span :model="total">${{total}}</span></td>
                    </tr>
                    <tr class="s-total">
                      <td>Shipping <span>${{Shipping}}</span></td>
                    </tr>
                    <tr class="g-total">
                      <td>Grand Total<span class="grand">${{total1}}</span></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <a  class="checkout" @click="goorder">Checkout</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- cart end -->
      <!-- client start -->

      <mcfoot></mcfoot>
    </div>
</template>

<script>
import mcheader from '@/components/Mcheader'
import mcfoot from '@/components/Mcfoot'
import https from './js/https.js'
export default {
  name: 'shopcar',
  components:
        {
          mcheader,
          mcfoot
        },
  data () {
    return {
      shopcarList: [],
      onetotal: '',
      total: 0,
      Shipping: 0,
      total1: 0
    }
  },
  methods: {
    getshop () {
      var userid = sessionStorage.getItem('userId')
      console.log(userid)
      if (userid == null) {
        this.open()
      } else {
        https.fetchGet('mocalilie/api/shopcar/queryShopcar', {
          // 传递的参数
          userId: userid
        }).then((res) => {
          console.log(res.data.data)
          // 获取的参数
          this.shopcarList = res.data.data
          // 计算总价
          if (res.data.data.length != 0) {
            this.total = 0
            for (var i = 0; i < res.data.data.length; i++) {
              this.onetotal = (parseInt((res.data.data[i].price)) * parseInt((res.data.data[i].productCount))).toFixed(2) // 价钱乘数量
              this.total = (parseInt(this.total) + parseInt(this.onetotal)).toFixed(2)
              console.log(this.total)
            }
            this.total1 = (parseInt(this.total) - parseInt(this.Shipping)).toFixed(2)
            console.log(this.onetotal)
          }
        })
      }
    },
    open () {
      this.$confirm('当前未登陆，请登陆你的账户', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        showCancelButton: false,
        center: true
      }).then(() => {
        this.$router.push('/login')
      })
    },
    getnext () {
      // 渲染滑动
      this.$nextTick(function () { // ==》更新dom后，执行轮播
        $('.tab-item-slider').owlCarousel({
          autoPlay: false,
          slideSpeed: 2000,
          pagination: false,
          navigation: true,
          items: 5,
          /* transitionStyle : "fade", */ /* [This code for animation ] */
          navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          itemsDesktop: [1199, 4],
          itemsDesktopSmall: [980, 3],
          itemsTablet: [768, 2],
          itemsMobile: [479, 1]
        })
        $('.client-owl').owlCarousel({
          autoPlay: false,
          slideSpeed: 2000,
          pagination: false,
          navigation: true,
          items: 6,
          /* transitionStyle : "fade", */ /* [This code for animation ] */
          navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          itemsDesktop: [1399, 6],
          itemsDesktopSmall: [980, 4],
          itemsTablet: [768, 2],
          itemsMobile: [479, 1]
        })
        $('.trend-item-slider').owlCarousel({
          autoPlay: false,
          slideSpeed: 2000,
          pagination: false,
          navigation: true,
          items: 3,
          /* transitionStyle : "fade", */ /* [This code for animation ] */
          navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          itemsDesktop: [1199, 2],
          itemsDesktopSmall: [980, 2],
          itemsTablet: [768, 2],
          itemsMobile: [479, 1]
        })
        $('.related-product-wrapper').owlCarousel({
          autoPlay: false,
          slideSpeed: 2000,
          pagination: false,
          navigation: true,
          items: 6,
          /* transitionStyle : "fade", */ /* [This code for animation ] */
          navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          itemsDesktop: [1399, 5],
          itemsDesktopSmall: [980, 3],
          itemsTablet: [768, 2],
          itemsMobile: [479, 1]
        })
        $('.testimonial-owl-wrap').owlCarousel({
          autoPlay: false,
          slideSpeed: 2000,
          pagination: false,
          navigation: true,
          items: 1,
          /* transitionStyle : "fade", */ /* [This code for animation ] */
          navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          itemsDesktop: [1399, 1],
          itemsDesktopSmall: [980, 1],
          itemsTablet: [768, 1],
          itemsMobile: [479, 1]
        })
        $('.tab-item-slider-two').owlCarousel({
          autoPlay: false,
          slideSpeed: 2000,
          pagination: false,
          navigation: true,
          items: 5,
          /* transitionStyle : "fade", */ /* [This code for animation ] */
          navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          itemsDesktop: [1399, 3],
          itemsDesktopSmall: [980, 3],
          itemsTablet: [768, 2],
          itemsMobile: [479, 1]
        })
        $('.tab-item-slider').owlCarousel({
          autoPlay: false,
          slideSpeed: 2000,
          pagination: false,
          navigation: true,
          items: 5,
          /* transitionStyle : "fade", */ /* [This code for animation ] */
          navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          itemsDesktop: [1199, 4],
          itemsDesktopSmall: [980, 3],
          itemsTablet: [768, 2],
          itemsMobile: [479, 1]
        })
        $('#slider-range').slider({
          range: true,
          min: -80,
          max: 460,
          values: [ 25, 325 ],
          slide: function (event, ui) {
            $('#amount').val('$' + ui.values[ 0 ] + ' - $' + ui.values[ 1 ])
          }
        })
        $('#amount').val('$' + $('#slider-range').slider('values', 0) +
          ' - £' + $('#slider-range').slider('values', 1))
        $('#nivoslider').nivoSlider({
          effect: 'random', // 设置幻灯变化效果
          slices: 15, // 动画效果参数
          boxCols: 8, // box动画效果参数
          boxRows: 4, // 动画效果参数
          animSpeed: 500,
          pauseTime: 5000,
          startSlide: 0,
          directionNav: true,
          controlNavThumbs: true,
          prevText: 'Pr <br /> ev',
          nextText: 'Ne <br /> xt',
          pauseOnHover: false,
          manualAdvance: false
        })
        this.$refs.mcheader.getsecond()
        console.log('aaa')
      })
    },
    DeleteShop (id) {
      console.log(id)
      https.fetchPost('mocalilie/api/shopcar/delShopcar', {
        id: this.shopcarList[id].shopcar_id
      }).then((res) => {
        console.log(res)
        this.getshop()
      })
    },
    goorder () {
      this.$router.push({
        name: 'order',
        query: {
          shopcarList: JSON.stringify(this.shopcarList),
          total1: this.total1
        }
      })
    }
  },
  created () {
    this.getnext()
    this.getshop()
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Shopcar.vue